module.exports = __webpack_public_path__ + "img/744.2fde1151.jpg";